@if (vm$ | async; as vm) {
  <div class="date">{{vm.time | formalDate}}</div>
  <div class="time">{{vm.time | date: 'shortTime'}}</div>
  <div class="weather">
    <i class="wi" [ngClass]="vm.weather.weatherCode?.toString() | openWeatherIcon"></i>
    <span> {{vm.weather.tempMax | number: '1.0-0'}}/{{vm.weather.tempMin | number: '1.0-0'}} &deg;F</span>
  </div>
}
